import { useState } from 'react'

function parseRange(value: string): { min: string; max: string } {
  if (!value) return { min: '', max: '' }
  if (value.endsWith('+')) {
    return { min: value.slice(0, -1), max: '' }
  }
  const parts = value.split('-')
  if (parts.length === 2) {
    return { min: parts[0] === '0' ? '' : parts[0], max: parts[1] }
  }
  return { min: '', max: '' }
}

function PriceRangeCustomInner({
  value,
  onApply,
}: {
  value: string
  onApply: (value: string) => void
}) {
  const initial = parseRange(value)
  const [minVal, setMinVal] = useState<string>(initial.min)
  const [maxVal, setMaxVal] = useState<string>(initial.max)

  function apply() {
    const min = minVal.trim()
    const max = maxVal.trim()
    if (!min && !max) {
      onApply('')
      return
    }
    if (min && !max) {
      onApply(`${min}+`)
      return
    }
    onApply(`${min || '0'}-${max || '999999'}`)
  }

  return (
    <div className="flex items-end gap-2 mt-2">
      <label className="flex flex-col flex-1 text-xs text-neutral-600">
        Min €
        <input
          type="number"
          min="0"
          inputMode="decimal"
          value={minVal}
          onChange={(e) => setMinVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') apply()
          }}
          className="mt-1 px-2 py-1 text-sm border border-neutral-200 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="0"
        />
      </label>
      <label className="flex flex-col flex-1 text-xs text-neutral-600">
        Max €
        <input
          type="number"
          min="0"
          inputMode="decimal"
          value={maxVal}
          onChange={(e) => setMaxVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') apply()
          }}
          className="mt-1 px-2 py-1 text-sm border border-neutral-200 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder=""
        />
      </label>
      <button
        type="button"
        onClick={apply}
        className="text-xs px-3 py-1.5 rounded border border-primary text-primary hover:bg-primary hover:text-white transition-colors"
      >
        Toepassen
      </button>
    </div>
  )
}

/**
 * Remounts `PriceRangeCustomInner` on every URL value change to avoid
 * setState-in-useEffect anti-pattern for syncing local inputs with URL state.
 */
export function PriceRangeCustom(props: {
  value: string
  onApply: (value: string) => void
}) {
  return <PriceRangeCustomInner key={props.value} {...props} />
}
